import { useState } from "react";
import { ClubApi } from "../../services/clubApi";

const ClubUnlockPage = () => {
  const [token, setToken] = useState("");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");
  const [newToken, setNewToken] = useState("");
  const [working, setWorking] = useState(false);

  const validate = async () => {
    try {
      setWorking(true);
      setError("");
      setResult("");
      const response = await ClubApi.validateUnlockToken(token);
      setResult(response.valid ? "Token valid. Redirect path ready." : "Token invalid.");
    } catch (err: any) {
      setError(err?.response?.data?.error || "Failed to validate token");
    } finally {
      setWorking(false);
    }
  };

  const rotate = async () => {
    try {
      setWorking(true);
      setError("");
      setResult("");
      const response = await ClubApi.rotateUnlockToken();
      setNewToken(response.token);
      setResult("New token generated. Save it now for QR/NFC.");
    } catch (err: any) {
      setError(err?.response?.data?.error || "Failed to rotate token");
    } finally {
      setWorking(false);
    }
  };

  return (
    <div className="mx-auto max-w-3xl px-4 py-5 text-white sm:px-5 sm:py-6">
      <h1 className="text-2xl font-bold">Club Unlock Token</h1>

      <div className="mt-4">
        <label className="block text-sm font-semibold">Validate Token</label>
        <input
          value={token}
          onChange={(event) => setToken(event.target.value)}
          className="mt-1 w-full rounded border border-white/20 bg-zinc-900 p-2"
          placeholder="Paste token from QR/NFC URL"
        />
      </div>

      <div className="mt-4 flex gap-3">
        <button
          onClick={validate}
          disabled={working || !token}
          className="rounded bg-zinc-700 px-4 py-2 disabled:opacity-60"
        >
          Validate
        </button>
        <button onClick={rotate} disabled={working} className="rounded bg-red-700 px-4 py-2 disabled:opacity-60">
          Rotate Token
        </button>
      </div>

      {newToken && (
        <div className="mt-4 rounded border border-yellow-400/40 bg-yellow-500/10 p-3">
          <p className="text-sm">New token (shown once):</p>
          <p className="mt-1 break-all font-mono text-xs">{newToken}</p>
        </div>
      )}

      {result && <p className="mt-4 text-green-400">{result}</p>}
      {error && <p className="mt-4 text-red-400">{error}</p>}
    </div>
  );
};

export default ClubUnlockPage;
